// src/App.js
import React from 'react';
import Canvas from './Canvas';

const App = () => {
  return (
    <div>
      <Canvas />
    </div>
  );
};

export default App;
